import type { PokerMatchState } from '../games/heads-up-poker';

/** Public hole provides are card-free notifications. A complete local history
 * may still use the existing engine replay, while missing/redacted deals must
 * display the recorded snapshot without recalculating a showdown. */
export function pokerReplayNeedsSnapshot(history: readonly { mv: unknown }[]): boolean {
  let provided = false;
  for (const { mv } of history) {
    if (typeof mv !== 'object' || mv === null || !('provide_my_hole' in mv)) continue;
    provided = true;
    const hole = mv.provide_my_hole;
    if (typeof hole !== 'object' || hole === null || !('cards' in hole)
      || !Array.isArray(hole.cards) || hole.cards.length !== 2) return true;
  }
  return !provided;
}

/** Published snapshots contain the server's outcome and chosen disclosure. */
export function pokerReplaySnapshot(snapshot: PokerMatchState): PokerMatchState {
  return structuredClone(snapshot);
}
